import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { DownloadSimple, UsersThree } from '@phosphor-icons/react';
import { API } from '../config/api';
import { Button } from './ui/button';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';

const fmt = (iso) => (iso ? new Date(iso).toLocaleDateString('it-IT') : '—');

/** Settings → Iscritti (Infismart staff only): companies registered, with a CSV export. */
export default function AdminUsersTab() {
  const [data, setData] = useState(null);
  const [downloading, setDownloading] = useState(false);

  useEffect(() => {
    axios.get(`${API}/admin/users`).then(r => setData(r.data)).catch(() => setData({ total: 0, users: [] }));
  }, []);

  const download = async () => {
    setDownloading(true);
    try {
      const r = await axios.get(`${API}/admin/users.csv`, { responseType: 'blob' });
      const url = URL.createObjectURL(r.data);
      const a = document.createElement('a');
      a.href = url; a.download = 'iscritti_infismart.csv'; a.click();
      setTimeout(() => URL.revokeObjectURL(url), 10000);
    } catch (err) {
      toast.error('Download non riuscito');
    } finally {
      setDownloading(false);
    }
  };

  if (!data) return null;
  return (
    <Card className="border border-[#E2E8F0] rounded-sm" data-testid="admin-users">
      <CardHeader className="border-b border-[#E2E8F0] pb-4">
        <div className="flex items-start justify-between gap-4 flex-wrap">
          <div>
            <CardTitle className="font-outfit text-lg font-semibold text-[#0A0F1A] flex items-center gap-2">
              <UsersThree size={20} className="text-[#0033A0]" /> Iscritti a Infismart
            </CardTitle>
            <p className="text-sm text-[#4A5568] mt-1">
              {data.total === 1 ? '1 azienda registrata' : `${data.total} aziende registrate`}. Visibile solo allo staff Infismart. A ogni nuova registrazione arriva un'email di avviso.
            </p>
          </div>
          <Button onClick={download} disabled={downloading || !data.total} className="bg-[#0033A0] hover:bg-[#0047AB] text-white" data-testid="admin-users-csv">
            <DownloadSimple size={18} className="mr-2" />{downloading ? 'Download...' : 'Scarica elenco (Excel/CSV)'}
          </Button>
        </div>
      </CardHeader>
      <CardContent className="p-0 overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-[#F4F6F8] text-left text-xs text-[#4A5568]">
            <tr>
              {['Nome', 'Email', 'Azienda', 'Telefono', 'Piano', 'Registrato il', 'Prova fino al', 'Ultimo accesso', 'Clienti', 'Preventivi'].map(h => (
                <th key={h} className="px-3 py-2 font-medium whitespace-nowrap">{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data.users.map(u => (
              <tr key={u.id} className="border-t border-[#E2E8F0]" data-testid="admin-user-row">
                <td className="px-3 py-2 whitespace-nowrap">{u.name || '—'}</td>
                <td className="px-3 py-2"><a href={`mailto:${u.email}`} className="text-[#0033A0] hover:underline">{u.email}</a></td>
                <td className="px-3 py-2">{u.company_name || '—'}</td>
                <td className="px-3 py-2 whitespace-nowrap">{u.company_phone || '—'}</td>
                <td className="px-3 py-2 whitespace-nowrap">{u.plan_name || '—'}</td>
                <td className="px-3 py-2 whitespace-nowrap">{fmt(u.created_at)}</td>
                <td className="px-3 py-2 whitespace-nowrap">{fmt(u.trial_expires_at)}</td>
                <td className="px-3 py-2 whitespace-nowrap">{fmt(u.last_login_at)}</td>
                <td className="px-3 py-2 text-right">{u.clients_count}</td>
                <td className="px-3 py-2 text-right">{u.quotes_count}</td>
              </tr>
            ))}
            {!data.users.length && (
              <tr><td colSpan={10} className="px-3 py-6 text-center text-[#4A5568]">Nessun iscritto per ora.</td></tr>
            )}
          </tbody>
        </table>
      </CardContent>
    </Card>
  );
}
